import UAA from '@/clients/uaa'
import API from '@/clients/api'
import { errorHandler } from '../helpers'

const confirmUser = async email => {
  const route = `admin/confirm`
  return UAA.post(route, { email })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const resetPassword = async emailAndPassword => {
  const { email, password } = emailAndPassword
  const route = `admin/password`
  return UAA.post(route, { email, password })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const suspendUser = async email => {
  const route = `admin/suspend`
  return UAA.post(route, { email })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const liftSuspension = async email => {
  const route = `admin/unsuspend`
  return UAA.post(route, { email })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const findUserForImpersonation = async email => {
  const route = `users?email_address=${email}`
  return API.get(route)
    .then(response => {
      if (response.data.data.length > 0) {
        return Promise.resolve(response.data.data[0].id)
      }
      return { message: 'Not a valid user. Please try again.' }
    })
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

export {
  confirmUser,
  resetPassword,
  suspendUser,
  liftSuspension,
  findUserForImpersonation,
}
